import { render } from "./Shelf.vue?vue&type=template&id=2548d79f&scoped=true"
import script from "./Shelf.vue?vue&type=script&lang=js"
export * from "./Shelf.vue?vue&type=script&lang=js"

import "./Shelf.vue?vue&type=style&index=0&id=2548d79f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2548d79f"]])

export default __exports__